import IoaWorkbenchError from './IoaWorkbenchError';

export default class AuthenticationError extends IoaWorkbenchError {
  constructor(msg) {
    super(`AuthenticationError: ${msg}`);
  }
}
